// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2259":"4fb45e88","6589":"4fb45e88","7639":"4fb45e88"}[chunkId] + ".chunk.css";
};